import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW9003Model } from '../kymw9003.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ユーザ権限の一覧を取得する。
 *
 * @export API通信成功時の処理
 * @class GetAuthoritySetListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAuthoritySetListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9003Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAuthoritySetListService
   */
  private getBody(): PlessRequest {
    let condition: any = {};

    // 権限に空欄以外が設定されている場合、権限をリクエストパラメータに含める
    if (!PlessViewUtilsSub.isEmpty( this.model.authoritySetName )) {
      condition["AuthoritySetName"] = this.model.authoritySetName;
    }
    condition["AdminDiv"] = this.model.adminDiv;
    condition["AuthorityStatus"] = this.model.authorityStatus;

    return new PlessRequest({
      search: {
        AuthoritySetList: {
          condition,
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAuthoritySetListService
   */
  execute(model: KYMW9003Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getAuthoritySetList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAuthoritySetListService
   */
  success(data: any) {
    this.model.updateAuthoritySetList(data);
    if ( this.successFunc !== null ) {
      this.successFunc(data);
    }
  }
}
